import React, { Component } from "react";
import NumPad from "react-numpad";
import { withTranslation } from "react-i18next";
import "./style.scss";
class NumPadKeyboardClass extends Component {
  render() {
    let {
      onChange,
      value,
      decimal = 2,
      negative = false,
      customClassName = "form-control text-right",
      placeholder = "Enter Here",
      sync,
      onClick,
    } = this.props;
    return (
      <div className="search-box input-group px-1 text-right">
        <NumPad.Number
          onChange={onChange}
          value={value}
          decimal={decimal}
          negative={negative}
          className={customClassName}
          placeholder={placeholder}
          sync={sync}
          onClick={onClick}
        />
      </div>
    );
  }
}

export const NumPadKeyboard = withTranslation()(NumPadKeyboardClass);
